// Frontend logger that writes to actual files via log server
import logger from './logger';

class FileLogWriter {
  constructor() {
    this.logServerUrl = process.env.REACT_APP_LOG_SERVER_URL || 'http://localhost:3001/log';
    this.isEnabled = process.env.REACT_APP_ENABLE_FILE_LOGGING === 'true';
    this.queue = [];
    this.isProcessing = false;
    this.serverAvailable = false;
    
    if (this.isEnabled) {
      this.setupLogInterceptor();
      this.checkServerAvailability();
    }
  }
  
  async checkServerAvailability() {
    try {
      const response = await fetch(this.logServerUrl.replace('/log', '/health'), {
        method: 'GET',
        mode: 'cors'
      });
      this.serverAvailable = response.ok;
    } catch (err) {
      this.serverAvailable = false;
    }
  }
  
  setupLogInterceptor() {
    // Store original methods
    const originalLog = logger.log.bind(logger);
    
    // Override main log method
    logger.log = (level, category, message, data) => {
      // Call original logger
      originalLog(level, category, message, data);
      
      // Send to file
      this.writeToFile({
        level,
        category,
        message,
        data,
        timestamp: new Date().toISOString()
      });
    };
    
    // Override convenience methods to ensure they also go through the new log method
    logger.debug = (category, message, data) => {
      logger.log('debug', category, message, data);
    };
    
    logger.info = (category, message, data) => {
      logger.log('info', category, message, data);
    };
    
    logger.success = (category, message, data) => {
      logger.log('success', category, message, data);
    };
    
    logger.warn = (category, message, data) => {
      logger.log('warn', category, message, data);
    };
    
    logger.error = (category, message, data) => {
      logger.log('error', category, message, data);
    };
    
    logger.system = (message, data) => {
      logger.log('system', 'SYSTEM', message, data);
    };
    
    // Silent initialization - no console output
  }
  
  async writeToFile(logEntry) {
    // Add to queue
    this.queue.push(logEntry);
    
    // Process queue if not already processing
    if (!this.isProcessing) {
      this.processQueue();
    }
  }
  
  async processQueue() {
    if (this.queue.length === 0) {
      this.isProcessing = false;
      return;
    }
    
    this.isProcessing = true;
    const batch = this.queue.splice(0, 10); // Process 10 at a time
    
    try {
      // Send logs to log server
      await Promise.all(batch.map(log => 
        fetch(this.logServerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(log)
        }).catch(err => {
          // Silently fail if log server is not running
        })
      ));
    } catch (error) {
      // Don't log errors about logging to avoid infinite loop
    }
    
    // Process next batch
    setTimeout(() => this.processQueue(), 100);
  }
}

// Create singleton instance
const fileLogWriter = new FileLogWriter();

export default fileLogWriter;